<!-- 巡检点管理 -->
<template>
  <div>
    <point-table ref="pointTable" />
  </div>
</template>

<script>
import PointTable from "./components/PointTable.vue";

export default {
  name: "inspection-point-manage",
  components: {
    PointTable,
  },
};
</script>

<style lang="scss" scoped>
</style>
